import React from 'react';
import { Link } from 'react-router-dom';

export default function PageUnderConstruction() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '50vh', padding: '40px 24px 120px',
      textAlign: 'center',
    }}>
      {/* Animated icon */}
      <div style={{
        width: 100, height: 100, borderRadius: '50%',
        backgroundColor: '#f5f5f5', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        marginBottom: 28, position: 'relative',
      }}>
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#161825" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
        </svg>
        {/* Pulsing ring */}
        <div style={{
          position: 'absolute', inset: -6, borderRadius: '50%',
          border: '2px solid #e0e0e0',
          animation: 'pulseRing 2s ease-in-out infinite',
        }} />
      </div>

      <h1 style={{
        fontSize: '24px', fontWeight: 700, color: '#161825',
        margin: '0 0 10px', lineHeight: 1.3,
      }}>
        Sidan är under uppbyggnad
      </h1>

      <p style={{
        fontSize: '15px', color: '#777', margin: '0 0 32px',
        maxWidth: '420px', lineHeight: 1.6,
      }}>
        Vi jobbar på att göra denna sida redo för dig. Kom tillbaka snart för att se det färdiga resultatet!
      </p>

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <button style={{
            padding: '12px 28px', borderRadius: '12px', border: 'none',
            backgroundColor: '#161825', color: '#fff', fontSize: '14px',
            fontWeight: 600, cursor: 'pointer', transition: 'background-color 0.2s',
          }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2a2d3a'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#161825'}
          >
            Till startsidan
          </button>
        </Link>
        <Link to="/topplista" style={{ textDecoration: 'none' }}>
          <button style={{
            padding: '12px 28px', borderRadius: '12px',
            border: '1.5px solid #e0e0e0', backgroundColor: '#fff',
            color: '#333', fontSize: '14px', fontWeight: 600,
            cursor: 'pointer', transition: 'all 0.2s',
          }}
            onMouseOver={(e) => { e.currentTarget.style.borderColor = '#161825'; e.currentTarget.style.backgroundColor = '#fafafa'; }}
            onMouseOut={(e) => { e.currentTarget.style.borderColor = '#e0e0e0'; e.currentTarget.style.backgroundColor = '#fff'; }}
          >
            Se posters
          </button>
        </Link>
      </div>

      <style>{`
        @keyframes pulseRing {
          0%, 100% { transform: scale(1); opacity: 0.4; }
          50% { transform: scale(1.15); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
